import React, { ReactNode } from "react";
import "./CardContent.css";

interface CardContentProps {
  qrSection: ReactNode;
  infoSection: ReactNode;
  className?: string;
}

const CardContent: React.FC<CardContentProps> = ({ 
  qrSection, 
  infoSection,
  className = "" 
}) => (
  <>
    <div className={`base-card-qr ${className}`}>{qrSection}</div>
    <div className="base-card-info">{infoSection}</div>
  </>
);

export default CardContent;